var Rights = {
  FRM_LIMITS: "FRMLIMITS",
  FRM_LOGIN: "FRMLOGIN",
  FRM_PREFERENCES_RACING: "FRMPREFERENCESRACING",
  FRM_CONSOLE: "FRMCONSOLE",
  FRM_TRACK_CATEGORY: "FRMTRACKCATEGORY",
  FRM_NEW_RACES: "FRMRACES",
  FRM_PAST_POST: "FRMPASTPOST",
  FRM_PAY_REBATES: "FRMPAYREBATES",
  FRM_SCORE_TICKETS: "FRMSCORETICKETS",
  FRM_PROFILE_TRACKS: "FRMLOCATIONTRACK",
  FRM_TRACKS_BY_BOOK: "FRMTRACKBYBOOK",
  FRM_TRACKS: "FRMTRACKS",
  FRM_LAST_CHANGES: "FRMLASTCHANGES",
  FRM_VOID_TICKET: "FRMVOIDTICKET",
  FRM_OPEN_TICKETS: "FRMMANUALSCORE",
};

export default Rights;
